// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/management/global-tables/global-tables.component.css
// module id = 488
// module chunks = 0